import { SearchesService } from '../services'

export default (id, msg) => {
  return SearchesService.saveCommentOC(id, msg)
    .then((response) => {
      if (!response) {
        const error = new Error('HTTP_ERROR')
        error.response = response
        return Promise.reject(error)
      }

      return response.data
    })
    .catch((error) => Promise.reject(error))
}
